import firebase from "firebase/app";

import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { FacebookAuthProvider, GoogleAuthProvider, getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: "priyanshdatyal-me.firebaseapp.com",
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: "priyanshdatyal-me",
  storageBucket: "priyanshdatyal-me.appspot.com",
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: "G-WCR5TN7GLH"
};


const app = initializeApp(firebaseConfig);
var auth =  getAuth(app);
auth.useDeviceLanguage()
const database = getDatabase(app)
const firestore = getFirestore(app)
var googleAuthProvider =   new GoogleAuthProvider;
var facebookAuthProvider =  new FacebookAuthProvider;

export {app, auth, database, firestore, googleAuthProvider, facebookAuthProvider}